<template>
	<div>
		<paginated-search v-bind="{ schema, searchEntities, exportEntity, autoEnable: true }"></paginated-search>
	</div>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Log from "@/models/log.model.vue";
	import Company from '@/models/company.model.vue';
	import ExpressoAux from '@/components/Espresso/EspressoAux.vue';
	import XLSX from 'xlsx';

	export default {
		components: {
			PaginatedSearch,
		},
		data() {
			return {
				schema: Log.getSchema(),
				companies: [],
				showModal: false,
				dateMask: "##/##/####",
			};
		},
		methods: {
			searchEntities(paginationParameters) {
				return Log.search(paginationParameters);
			},
			exportEntity(parameters) {
				parameters.download = true;
				if (parameters.name === "%undefined%")
					delete parameters["name"]
				if((parameters.email === "%undefined%"))
					delete parameters["email"]
				Log.search(parameters)
					.then((response) => {
						const exportWS = XLSX.utils.json_to_sheet(response);
						const wb = XLSX.utils.book_new();

						XLSX.utils.book_append_sheet(wb, exportWS, 'export');

						// export Excel file
						XLSX.writeFile(wb, 'acessos.xlsx');
					})
					.catch(() => ExpressoAux.showWarningModal("Não foi possível encontrar registros."));
			},
		},
		created() {
			Company.getAll()
			.then((companies) => {
				this.companies = companies.map(company => ({
					name: company.name,
					value: company.id,
				}));
			})
			.catch((err) => console.log(err));
		}
	}
</script>
